module.exports = __webpack_public_path__ + "static/media/moment12.70bb7f26.webp";